import React, { FC, useState, useEffect, useRef } from 'react';
import { useQuery, useMutation } from '@apollo/react-hooks';
import { useDispatch } from 'react-redux';

import AudienceProfileList from '../../components/AudienceProfile';
import withErrorBoundary from '../../hoc/ErrorBoundary';
import {
  InstitutionalInterest_GQL,
  UserPrefsById_GQL,
  UserPrefsCreate,
  UserPrefsUpdate,
} from './gqlQuery';

import { audienceProfileConfig } from '../../../store/audienceProfileConfig';
import { parentProfileConfig } from '../../../store/parentProfileConfig';
import { toastMessage } from '../Toast/actions/toast.actions';

const AudienceProfileListContainer: FC<any> = (props: any) => {
  const { inst_id, audience_key, account_id, visitorType } = props;
  const [configMenu, setConfigMenu] = useState(false);
  const [prefId, setPrefId] = useState(null);
  const [profileSections, setProfileSections] = useState(
    visitorType?.includes('parent')
      ? parentProfileConfig
      : audienceProfileConfig
  );
  const Dispatch = useDispatch();

  useEffect(() => {
    if (visitorType?.includes('parent')) {
      setProfileSections(parentProfileConfig);
    } else {
      setProfileSections(audienceProfileConfig);
    }
  }, [visitorType]);

  const { loading: instLoading, error: instError, data: instData } = useQuery(
    InstitutionalInterest_GQL,
    {
      variables: { inst_id, audience_key },
    }
  );

  const { data: userPrefAllData } = useQuery(UserPrefsById_GQL, {
    variables: { inst_id, account_id },
    onCompleted: (userPrefAllData: any) => {
      let userPrefObj =
        userPrefAllData &&
        userPrefAllData.userPrefs &&
        userPrefAllData.userPrefs.filter(
          (pref: any) => pref.category === 'field_configuration'
        );

      const userPref = userPrefObj && userPrefObj.length > 0 && userPrefObj[0];

      const sections = userPref
        ? JSON.parse(userPref.value)
        : visitorType?.includes('parent')
        ? parentProfileConfig
        : audienceProfileConfig;

      setProfileSections(sections);
      setPrefId(userPref ? userPref.id : null);
    },
  });

  let userPrefPayload = {
    variables: { inst_id, account_id },
    onCompleted: (data: any) => {
      const key = Object.keys(data)[0];
      const sections = JSON.parse(data[key].data.value);
      const prefId = JSON.parse(data[key].data.id);
      setProfileSections(sections);
      setPrefId(prefId);
    },
  };

  const [createUserPref] = useMutation(UserPrefsCreate, userPrefPayload);
  const [updateUserPref] = useMutation(UserPrefsUpdate, userPrefPayload);

  const setUserPreferences = (prefId: any, sections: any) => {
    userPrefPayload.variables['value'] = JSON.stringify(sections);
    if (!prefId) {
      createUserPref();
    } else {
      userPrefPayload.variables['id'] = prefId;
      updateUserPref();
    }
  };

  return (
    <AudienceProfileList
      loading={instLoading}
      error={instError}
      data={
        instData &&
        instData.audience.audience &&
        instData.audience.audience.profile
          ? instData.audience.audience.profile
          : {}
      }
      profileSections={profileSections}
      setProfileSections={(sections: any) => {
        setUserPreferences(prefId, sections);
      }}
      configMenu={configMenu}
      showConfigMenu={(val: any) => setConfigMenu(val)}
      showToastMessage={() =>
        Dispatch(
          toastMessage({
            message: 'Changes are applied',
            position: 'bottom',
          })
        )
      }
    />
  );
};

export default withErrorBoundary(AudienceProfileListContainer);
